import { http } from '@/libs/util'
import util from '@/libs/util'
const { 
    account_finance_balance_monthly_ledger_query_difference,
    cash_balance_import,
    // cash_balance/import
 } = util.api || {}

// 获取薪资发放-薪资概要
export function getAccountFinanceBalanceMonthlyLedgerQueryDifferenceApi(params) {
 return http.get(account_finance_balance_monthly_ledger_query_difference, params)
}
export function importDataApi(params) {
    return http.post_upload(cash_balance_import, params)
}